PublicationEditController.$inject = ['$scope', 'publicationToEdit', 'isDuplication', '$mdDialog', 'parentPublication'];
export function PublicationEditController(
  $scope,

  publicationToEdit,
  isDuplication,
  $mdDialog,
  parentPublication
) {
  $scope.isDuplication = isDuplication;
  $scope.parentPublication = parentPublication;
  $scope.publicationToEdit = publicationToEdit;
  $scope.closeNgDialog = closeNgDialog;

  function closeNgDialog(publication) {
    $mdDialog.hide(publication);
  }
}
